import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
// Self-hosted Inter (variable). Every typography token in DESIGN.md names Inter, but
// the font was never actually loaded — no @font-face, no package, no files in public/ —
// so the whole app silently fell back to system-ui. Imported before index.css so the
// @font-face rules are registered before anything references var(--font-app).
import "@fontsource-variable/inter";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { SentryErrorBoundary } from "./components/SentryErrorBoundary";

// Initialize Sentry before rendering the app
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SentryErrorBoundary>
  </React.StrictMode>
);
